var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarMedico1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2102_69925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.390015,
    y: 0.389954,
    width: 188.769,
    height: 188.769,
    rx: 94.3847,
    fill: "#8DBEE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.817 103.992V193.236H76.1116L37.4854 154.673L94.824 97.4277L72.1287 74.7693L120.807 26.108L198.817 103.992Z",
    fill: "#024E88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9274 154.672C74.4678 154.672 56.0084 154.672 37.4854 154.672C38.2443 134.539 41.405 111.565 58.8533 108.599C74.0887 106.074 78.1979 106.832 84.5195 86.3826C92.2322 87.4556 93.6863 87.4556 101.335 86.3826C107.657 106.832 111.83 106.074 127.065 108.599C144.45 111.565 147.674 134.539 148.369 154.672C129.91 154.672 111.45 154.672 92.9274 154.672Z",
    fill: "#2E83C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7267 106.579C76.6805 104.686 80.0942 100.836 84.5196 86.3826C92.2323 87.4556 93.6864 87.4556 101.335 86.3826C105.824 100.836 109.238 104.686 116.192 106.579C91.6631 134.539 94.1919 134.539 69.7267 106.579Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7267 106.579C76.6805 104.686 80.0942 100.836 84.5196 86.3826C92.2323 87.4556 93.6864 87.4556 101.335 86.3826C103.738 94.0825 105.824 98.8161 108.29 101.783C99.8817 103.676 87.9967 107.21 75.9854 113.774C74.0887 111.628 72.0028 109.23 69.7267 106.579Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.726 54.2572V70.9196C124.726 88.4021 110.439 102.666 92.9274 102.666C75.4794 102.666 61.1924 88.4021 61.1924 70.9196V54.2572H124.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.726 54.2572V64.7972C113.157 66.8171 88.1863 73.0021 68.2726 90.8635C63.8476 85.4357 61.1924 78.493 61.1924 70.9196V54.2572H124.726Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1924 62.9671H124.726V36.6483C124.726 27.6858 117.393 20.3644 108.416 20.3644H77.5024C68.5256 20.3644 61.1924 27.6858 61.1924 36.6483V62.9671Z",
    stroke: "#2E83C4",
    fill: "#2E83C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2102_69925"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.390015,
    y: 0.389954,
    width: 188.769,
    height: 188.769,
    rx: 94.3847,
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMedico1);
export default __webpack_public_path__ + "static/media/Avatar=Medico 1.7bd7c9b34221f88ad55bf0625a7060fd.svg";
export { ForwardRef as ReactComponent };